export default "__VITE_ASSET__C_plM$PM__"